import formGroup0GraphicManager from './formGroupGraphicManagers/formGroup0GraphicManager';
import formGroup1GraphicManagerManifests from './formGroupGraphicManagers/formGroup1GraphicManagerManifests';
import formGroup2GraphicManagerHistoric from './formGroupGraphicManagers/formGroup2GraphicManagerHistoric';

export default {
  title: 'Graphic manager Run',
  attributeName:'graphicmanager',
  createURL: 'graphicmanager',
  sessionParams: [],
  getURL: 'graphicmanagers/run',
  updateURL: 'graphicmanagers/run',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroup0GraphicManager,
    formGroup1GraphicManagerManifests,
    formGroup2GraphicManagerHistoric,
  ],
  // websocketNavigation:'users_navigation',
  //navigationBlockReaders:true,

  // saveIdSessionNameAs: 'liveId',
  // websocketChannel: 'liveEdit-liveId',
  // websocketSessionParams: ['liveId'],
  // websocketItems:['status_live','status_cloud','status_ingest','globalLive']

};
